import React, { ReactElement } from "react";
import RateStarIcon from "@components/svg/rateStarIcon";

const StarRating = ({
    rating,
    max = 5,
}: {
    rating: number;
    max?: number;
}): ReactElement => (
    <div className="flex items-center">
        {Array.from({ length: max }, (_, i) => {
            const fill = Math.max(0, Math.min(1, rating - i));

            return (
                <div key={i} className="relative text-2xl">
                    <RateStarIcon empty={true} />
                    <span
                        className="absolute left-0 top-0 overflow-hidden text-yellow-400"
                        style={{ width: `${fill * 100}%` }}
                    >
                        <RateStarIcon />
                    </span>
                </div>
            );
        })}
    </div>
);

export default StarRating;
